import { Link as MaterialLink, LinkProps, SvgIconProps } from '@mui/material';
import clsx from 'clsx';
import React, { cloneElement, ReactElement, ReactNode } from 'react';

interface Props extends LinkProps {
  // Change the type to ReactElement to allow cloning
  icon?: ReactElement<SvgIconProps>;
  disabled?: boolean;
}

export const Link = React.forwardRef<HTMLAnchorElement, Props>(
  (
    { children, className, icon, disabled, underline = 'always', color = 'primary', 'aria-label': ariaLabel, ...props },
    ref
  ) => {
    const combinedContent: ReactNode = icon ? (
      <>
        <span>{children}</span>
        {cloneElement(icon, {
          sx: { fontSize: 'inherit', verticalAlign: 'middle', marginLeft: '0.25em', marginTop: '-0.125em' },
        })}
      </>
    ) : (
      children
    );

    const accessibilityProps = {
      'aria-disabled': disabled ? true : undefined,
      'aria-label': ariaLabel || (typeof children === 'string' ? children : undefined),
      tabIndex: disabled ? -1 : undefined,
    };

    return (
      <MaterialLink
        className={clsx(className, { disabled })}
        underline={underline}
        color={color}
        {...props}
        {...accessibilityProps}
        ref={ref}
      >
        {combinedContent}
      </MaterialLink>
    );
  }
);

Link.displayName = 'Link';
